export const UFsToAutocomplete = ['SP']
